<template>
  <Dialog
    class="sdkConsultDialog"
    :theme="theme"
    @close="close"
    :buttons="buttons"
  >
    <div v-if="!showQr">
      <h1 class="title">通话须知</h1>
      <ul>
        <li>
          <dt>发起通话</dt>
          <dd>请在协商的咨询时间邀请来访者通话</dd>
        </li>
        <li>
          <dt>提醒来访者进入APP</dt>
          <dd>
            若来访者离线或太久未接听，请用私信/电话联系来访者登录APP进行咨询。
          </dd>
        </li>
      </ul>
    </div>
    <div class="content-wrpa" v-else>
      <v-touch @tap="cancel" tag="span" class="close-btn">
        <i class="yxl-font yxl-font-close"></i>
      </v-touch>
      <img class="qr" src="../../assets/images/qr-code.png" />
      <p class="text">语音咨询只支持在APP上进行<br />请扫码下载APP</p>
    </div>
  </Dialog>
</template>

<script>
export default {
  props: {
    cancel: {
      required: false
    },
    process: {
      required: false
    },
    showQr: {
      required: false
    }
  },
  data() {
    return {
      theme: '#0B8BFF'
      //      buttons:
    }
  },
  computed: {
    buttons() {
      if (this.showQr) {
        return []
      } else {
        return [
          {
            label: '取消'
          },
          {
            label: '发起通话'
          }
        ]
      }
    }
  },
  mounted() {
    console.log(this.buttons)
  },
  methods: {
    close(button, index) {
      console.log('close', index)
      if (index === 1) {
        this.process()
      } else {
        this.cancel()
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/sass/mixin';

@function pxToRem($rem) {
  @return ($rem/75) * 1rem;
}

.sdkConsultDialog {
  /deep/ .dialog-cont {
    /*width: 80% !important;*/
  }
  .close-btn {
    display: block;
    position: absolute;
    right: pxToRem(20);
    top: pxToRem(20);
    @include font-dpr(16px);
    color: #999;
  }
  .title {
    font-weight: bold;
    margin-bottom: 24px;
    font-size: 17px;
    color: #333333;
    text-align: center;
    line-height: 24px;
  }
  .content-wrpa {
    text-align: center;

    .qr {
      width: pxToRem(248);
      height: pxToRem(248);
      display: inline-block;
    }
    .text {
      color: #666;
      font-size: pxToRem(26);
      margin-top: pxToRem(36);
    }
  }
  ul {
    margin: 0 24px 0 12px;
    padding-left: 12px;

    li {
      margin-bottom: 15px;
    }

    dt {
      position: relative;
      font-size: 14px;
      color: #333333;
      line-height: 24px;

      &:before {
        position: absolute;
        left: -10px;
        top: 12px;
        margin-top: -2px;
        content: '';
        display: block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #0b8bff;
      }
    }

    dd {
      font-size: 13px;
      color: #666666;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// sdkConsultDialog.vue?5cffd526